export default "__VITE_ASSET__2389cb32__"